// Step 11c · C3c — small pieces of the Sampling list (kept out of Sampling.jsx). EN + AR: lib/i18n/1966_s11c3c_sampling.js.
//   find 16: the population badge — a journal-entry (A9001) sample showed "HEAD-WISE ONLY" (any source that was not
//            "combined" / "main GL only" fell into the head-wise label); it now names the JE population / the worksheet.
//   finds 20 / 21: the sample's stats line — "n 25 as entered (the MUS formula gives 8,524)" and "FS head 3203 only: …".
import React from "react";
import { fmtCount } from "@/components/Amount";

export function sourceBadgeText(src, t) {
  const s = String(src || "");
  if (s.startsWith("je:")) return t("s11c3c.sampling.badgeJe");
  if (s.startsWith("ws:")) return t("s11c3c.sampling.badgeWs");
  if (s === "maingl_only") return t("sampling.mainOnly");
  return t("sampling.headOnly");
}

export function C3cStatsLines({ s, t }) {
  const st = s?.stats || {};
  const hf = st.head_filter;
  return (
    <>
      {st.n_basis === "entered" && (
        <div data-testid={`sample-n-entered-${s.id}`}>
          {t("s11c3c.sampling.nEntered").replace("{n}", fmtCount(st.planned_n ?? s.sample_size)).replace("{f}", fmtCount(st.n_formula))}
        </div>
      )}
      {hf && (
        <div data-testid={`sample-head-filter-${s.id}`}>
          {t("s11c3c.sampling.headFilter").replace("{head}", hf.fs_code).replace("{after}", fmtCount(hf.lines_after)).replace("{before}", fmtCount(hf.lines_before))}
        </div>
      )}
    </>
  );
}
